export default "/images/e21261502d11bab3b677e4e8e1dbf4d4.avif";